/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zalo_Not_ConnectedInputs */

const vi_error_zalo_not_connected = /** @type {(inputs: Error_Zalo_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa kết nối Zalo OA. Vào tab Kết nối bấm "Kết nối Zalo OA".`)
};

/**

* @param {Error_Zalo_Not_ConnectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_not_connected = /** @type {((inputs?: Error_Zalo_Not_ConnectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Not_ConnectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_not_connected(inputs)
});